import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';

import Type from '@nerdwallet/react-typography';
import Link from '@nerdwallet/react-link';
import CompanyJobListTile from './company-job-list-tile';

import ImageHero from '../../image-hero/image-hero';
import CompanyHeader from '../company-header/company-header';
import CompanyStroke from '../../company-stroke/company-stroke';

import DepartmentMappings from '../../../lib/company-content-src/department-mappings';

const CompanyJobList = ({ jobs, currentDept }) => {
  const renderedJobs = _.map(jobs, (job, id) => (
    <CompanyJobListTile {...job} key={`item-${id}`} />
  ));

  return (
    <div>
      <ImageHero
        preheader="Careers"
        title={DepartmentMappings[currentDept].name}
        body={DepartmentMappings[currentDept].body}
        bodyMobile={DepartmentMappings[currentDept].bodyMobile}
        backgroundClassName={
          DepartmentMappings[currentDept].backgroundClassName
        }
        opacityLevel={DepartmentMappings[currentDept].opacityLevel}
      />
      <CompanyHeader headerText="Current Openings" />
      <div
        className={classNames([
          'joblist__cont',
          classes('margin-horizontal-3'),
          classes('margin-horizontal-auto--wide'),
          classes('margin-vertical-0'),
        ])}
      >
        <div>
          {jobs.length > 0 ? (
            <Fragment>
              <div
                className={classNames([
                  'joblist__hdr',
                  classes('display-none'),
                  classes('display-flex--wide'),
                  classes('flex-direction-row'),
                  classes('justify-content-space-between'),
                  classes('padding-bottom-3'),
                ])}
              >
                <Type
                  default
                  uppercase
                  size="1"
                  color="neutral-dark"
                  className={classNames(['joblist__hdr--job'])}
                >
                  role
                </Type>
                <Type
                  default
                  uppercase
                  size="1"
                  color="neutral-dark"
                  className={classNames(['joblist__hdr--location'])}
                >
                  location
                </Type>
              </div>
              <div>{renderedJobs}</div>
            </Fragment>
          ) : (
            <div>
              <Type
                chronicle
                size="4"
                color="neutral-darkest"
                className={classNames([
                  classes('text-align-center'),
                  classes('margin-bottom-4'),
                ])}
              >
                No current openings
              </Type>
              <Type
                default
                size="2"
                color="neutral-darkest"
                className={classNames([
                  classes('text-align-center'),
                  classes('margin-bottom-4'),
                ])}
              >
                We don&apos;t have any openings, but let us know if you are
                interested.
              </Type>
              <div className={classNames([classes('text-align-center')])}>
                <Link href="mailto:jobs@nerdwallet.com">Get in touch</Link>
                <CompanyStroke />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

CompanyJobList.displayName = 'Company Job List';

CompanyJobList.propTypes = {
  jobs: PropTypes.arrayOf(PropTypes.shape(CompanyJobList.propTypes)),
  className: PropTypes.string,
  id: PropTypes.number,
  currentDept: PropTypes.string,
};

export default CompanyJobList;
